<app-toolbar></app-toolbar>
<app-splash [animationType]="splashAnimationType()" [duration]="3" [animationDuration]="0.5"></app-splash>
<router-outlet></router-outlet>
